import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
});

/* ---------- admin session ---------- */
const TOKEN_KEY = "schema_admin_token";

export const getToken = () => {
  try {
    return window.localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
};

export const setToken = (t) => {
  try {
    if (t) window.localStorage.setItem(TOKEN_KEY, t);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* private browsing — session just won't persist */
  }
};

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

/* A direct URL, for downloads the browser must fetch itself (PDF, .ics). */
export const fileUrl = (path) => `${BASE}/api${path}`;

/* Pull a readable message out of whatever the server said. */
export const errMessage = (e, fallback = "Something went wrong. Try again?") => {
  const d = e?.response?.data;
  if (typeof d?.detail === "string") return d.detail;
  if (Array.isArray(d?.detail) && d.detail.length) {
    const first = d.detail[0];
    if (first?.msg) {
      const field = (first.loc || []).filter((l) => l !== "body").join(" ");
      return field ? `${field}: ${first.msg}` : first.msg;
    }
  }
  if (e?.message === "Network Error") return "We couldn't reach the server.";
  return fallback;
};

/* Download a file that needs an auth header (CSV exports). */
export const downloadAuthed = async (path, filename) => {
  const res = await api.get(path, {
    responseType: "blob",
    headers: authHeader(),
  });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
